<template>
    <div>
        <div>
            <img
                v-if="order.photoUrl"
                :src="order.photoUrl"
                :class="$style.order_icon"
            />
            <Typography
                is="div"
                type="header"
                size="s"
            >
                {{
                    order.description
                        ? $tr('paymentModal.orderHeaderDescription', {
                              description: order.description,
                              amount: order.amount.toString(),
                          })
                        : $tr('paymentModal.orderHeader', {
                              game: order.gameTitle,
                              amount: order.amount.toString(),
                          })
                }}
            </Typography>
            <Typography
                is="div"
                v-if="order.subtitle"
                type="paragraph"
                size="xs"
                :class="$style.subtitle"
            >
                {{ order.subtitle }}
            </Typography>
        </div>
        <PurchaseInfo
            v-if="showPayment"
            :title="$tr('paymentModal.buyGam', { amount: amount.toString() })"
        />
        <Typography
            is="div"
            v-if="balance > 0 && showPayment"
            type="paragraph"
            size="xs"
            :class="$style.subtitle"
        >
            {{ $tr('paymentModal.paymentExplanation', { balance: balance.toString() }) }}
        </Typography>
    </div>
</template>
<script setup lang="ts">
import Typography from '@/components_new/Typography.vue'
import { Order } from '@/modules/in-game-payments'

import PurchaseInfo from './PurchaseInfo.vue'

defineProps<{
    order: Order
    amount: number
    balance: number
    showPayment: boolean
}>()
</script>

<style module>
.order_icon {
    width: 64px;
    height: 64px;
    margin-bottom: 16px;
}

.subtitle {
    color: var(--white-60);
    margin-top: 4px;
}
</style>
